import { useState, useEffect } from "react";
import { GIVEAWAY } from "@/data/giveaway";

const pad = (n) => String(n).padStart(2, "0");

const getRemaining = () => {
  const diff = new Date(GIVEAWAY.endDate).getTime() - Date.now();
  if (diff <= 0) return { days: 0, hours: 0, mins: 0, secs: 0, ended: true };
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff / 3600000) % 24),
    mins: Math.floor((diff / 60000) % 60),
    secs: Math.floor((diff / 1000) % 60),
    ended: false,
  };
};

export const Countdown = () => {
  const [t, setT] = useState(getRemaining());

  useEffect(() => {
    const id = setInterval(() => setT(getRemaining()), 1000);
    return () => clearInterval(id);
  }, []);

  const units = [
    { label: "Days", value: t.days },
    { label: "Hrs", value: t.hours },
    { label: "Min", value: t.mins },
    { label: "Sec", value: t.secs },
  ];

  return (
    <div className="flex items-center gap-2 sm:gap-3" data-testid="countdown-timer">
      {units.map((u, i) => (
        <div key={u.label} className="flex items-center gap-2 sm:gap-3">
          <div className="flex flex-col items-center">
            <div className="glass rounded-md min-w-[58px] sm:min-w-[74px] px-2 py-2.5 sm:py-3 border-white/10">
              <span className="font-display text-3xl sm:text-4xl text-white tabular-nums leading-none">
                {pad(u.value)}
              </span>
            </div>
            <span className="mt-2 text-[10px] font-body font-bold tracking-widest uppercase text-gray-400">
              {u.label}
            </span>
          </div>
          {i < units.length - 1 && (
            <span className="font-display text-2xl sm:text-3xl text-ember/60 -mt-5">:</span>
          )}
        </div>
      ))}
    </div>
  );
};
